import React from 'react';
export var AuthorsList = function AuthorsList(_ref) {
  var values = _ref.values,
    handleClick = _ref.handleClick;
  if (values) {
    return React.createElement('ul', {
      className: 'autores'
    }, values.map(function (item) {
      return {
        value: (item || {})._id || (item || {}).value,
        label: (item || {}).nome || (item || {}).label
      };
    }).map(function (item) {
      return handleClick ? React.createElement('li', {
        className: 'author-button',
        key: item.value,
        role: 'button',
        onClick: function onClick() {
          handleClick(item.value);
        }
      }, item.label) : React.createElement('li', {
        key: item.value
      }, item.label);
    }));
  }
  return null;
};
export default AuthorsList;